<!-- @format -->

<ng-container *transloco="let t">
  @if (showBreadcrumbs) {
    <nav [attr.aria-label]="t('ARIA_LABEL.BREADCRUMBS')" class="sis-mb-md">
      <ol class="breadcrumb">
        @if (breadcrumbs.length > 1 || showHomeNode === true) {
          <li class="home">
            <a fudisLink [title]="t('SIS_COMPONENTS.BREADCRUMB.HOME')" [href]="homeUrl"></a>
            <sis-icon icon="chevron"></sis-icon>
          </li>
        }
        @for (item of breadcrumbs; track item; let isLast = $last) {
          @if (!isLast) {
            <li>
              @if (item.isLink) {
                <a fudisLink [title]="item.displayName" [uiSref]="item.route"></a>
              }
              @if (!item.isLink) {
                <span>{{ item.displayName }}</span>
              }
              <sis-icon icon="chevron"></sis-icon>
            </li>
          }
          @if (isLast && showLastNode === true) {
            <li aria-current="page">{{ item.displayName }}</li>
          }
          @if (isLast && showLastNode === false) {
            <li class="visually-hidden" aria-current="page">{{ item.displayName }}</li>
          }
        }
      </ol>
    </nav>
  }
</ng-container>
